import { Box, Button, Card, Drawer, Stack, styled } from "@mui/material"
import theme from "../../app/theme"

export const GridParent = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
`

interface StyledTabPanelProps {
  hidden: boolean
}
export const StyledTabPanel = styled(Box)<StyledTabPanelProps>`
  flex-grow: 1;
  background: white;
  height: 100%;
`

export const CategoriesContainer = styled(Stack)`
  display: flex;
  flex: 1;
  background: white;
  padding: 20px;
  position: relative;
  height: 100%;
`
export const CategoriesTableContainer = styled(Stack)`
  display: flex;
  flex: 1;
  background: white;
  padding-inline: 20px;
  position: relative;
`

export const StyledCard = styled(Card)`
  && {
    background-color: #f4f7fa;
    justify-items: flex-start;
  }
`

interface ContentWrapperProps {
  isOpen: boolean
  drawerWidth: number
}

export const ContentWrapper = styled(Box)<ContentWrapperProps>(
  ({ isOpen, drawerWidth }) => ({
    display: "flex",
    flex: 1,
    transition: "all 0.3s ease",
    width: isOpen ? `calc(100% - ${drawerWidth}px)` : "100%",
    marginRight: isOpen ? `${drawerWidth}px` : 0,
    height: "100%",
  }),
)

export const StyledButton = styled(Button)(({ theme }) => ({
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: "24px",
  backgroundColor: "white",
  padding: "10px 18px",
  borderRadius: "8px",
  color: "#263238",
  border: "1px solid #d0d5dd",
  textTransform: "unset",
  boxShadow: "0px 1px 2px 0px #0000000d",
  [theme.breakpoints.down("sm")]: {
    flex: 1,
    fontSize: "12px",
  },
}))

export const PrimaryButton = styled(StyledButton)`
  background-color: #ffc100;
  border: none;
`

export const StyledFilterDrawer = styled(Drawer)(() => ({
  "& .MuiPaper-root": {
    width: "300px",
    border: "none",
    borderRadius: "20px 0px 0px 20px",
    position: "absolute",
    zIndex: 100,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}))

export const StyledCircle = styled("div")`
  width: 12px;
  height: 12px;
  background-color: #ff5630;
  line-height: 12px;
  border-radius: 1rem;
  color: #ffff;
  text-align: center;
  font-size: 12px !important;
`
